import React from "react"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Container = styled.div`
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
`

const IndexPage = () => (
  <Layout>
    <SEO title="Terms & Conditions" />
    <Container>
      <h1>WEBSITE TERMS AND CONDITIONS</h1>
      <p>
        These terms of use (“Terms”) set out the rules for using our website at
        http://www.stackglobal.io/ (the “Services”). By using the Services, you
        confirm that you accept these Terms and that you agree to comply with
        them. If you do not agree to these Terms, you must not use the Services.
        We may amend these Terms from time to time. We recommend that you print
        a copy of these terms for future reference.
      </p>
      <p>These Terms were last updated on 8 October 2019.</p>
      <h2>WHO WE ARE</h2>
      <p>
        http://www.stackglobal.io/ is a site operated by [Stack International
        Limited] (”We,” “us”). We are registered in England and Wales under
        company number [12022565] and have our registered office at [8th Floor
        Newater House, 11 Newhall Street, Birmingham, United Kingdom, B3 3NY].
      </p>
      <p>To contact us, please email hello@stackglobal.io</p>
      <p>WE MAY SUSPEND OR WITHDRAW THE SITE</p>
      <p>
        We do not guarantee that our site, or any content on it, will always be
        available or be uninterrupted. We may suspend or withdraw or restrict
        the availability of all or any part of our site for business and
        operational reasons. We will try to give you reasonable notice of any
        suspension or withdrawal.
      </p>
      <h2>WE MAY TRANSFER THIS AGREEMENT</h2>
      <p>
        We may transfer our rights and obligations under these Terms to another
        organisation. We will always tell you in writing if this happens and we
        will ensure that the transfer will not affect your rights under the
        contract.
      </p>
      <h2>HOW YOU MAY USE MATERIAL ON THE SITE</h2>
      <p>
        We are the owner or the licensee of all intellectual property rights in
        our site, and in the material published on it. Those works are protected
        by copyright laws and treaties around the world. All such rights are
        reserved.
      </p>
      <p>
        You may print off one copy, and may download extracts, of any page(s)
        from our site for your personal use and you may draw the attention of
        others within your organisation to content posted on our site.
      </p>
      <p>
        You must not modify the paper or digital copies of any materials you
        have printed off or downloaded in any way, and you must not use any
        illustrations, photographs, video or audio sequences or any graphics
        separately from any accompanying text.
      </p>
      <p>
        Our status (and that of any identified contributors) as the authors of
        content on our site must always be acknowledged.
      </p>
      <p>
        You must not use any part of the content on our site for commercial
        purposes without obtaining a licence to do so from us or our licensors.
      </p>
      <p>
        If you print off, copy or download any part of our site in breach of
        these Terms, your right to use our site will cease immediately and you
        must, at our option, return or destroy any copies of the materials you
        have made.
      </p>
      <h2>DO NOT RELY ON ANY INFORMATION ON THIS SITE</h2>
      <p>
        The content on our site is provided for general information only. It is
        not intended to amount to advice on which you should rely. You must
        obtain professional or specialist advice before taking, or refraining
        from, any action on the basis of the content on our site.
      </p>
      <p>
        Although we make reasonable efforts to update the information on our
        site, we make no representations, warranties or guarantees, whether
        express or implied, that the content on our site is accurate, complete
        or up to date.
      </p>
      <p>WE ARE NOT RESPONSIBLE FOR WEBSITES WE LINK TO</p>
      <p>
        Where our site contains links to other sites and resources provided by
        third parties, these links are provided for your information only. Such
        links should not be interpreted as approval by us of those linked
        websites or information you may obtain from them.
      </p>
      <p>We have no control over the contents of those sites or resources.</p>
      <p>OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU</p>
      <p>
        We, will not be liable to you for any loss or damage, whether in
        contract, tort (including negligence), breach of statutory duty, or
        otherwise, even if foreseeable, arising under or in connection with your
        use of, or inability to use the Services; or use of or reliance on any
        content displayed on the Services. In particular, we will not be liable
        for loss of profits, sales, business, or revenue; business interruption;
        loss of anticipated savings, loss of business opportunity, goodwill or
        reputation; or any indirect or consequential loss or damage.
      </p>
      <p>
        We do not provide any warranty or guarantee as to the accuracy,
        timeliness, performance, completeness or suitability of the information
        and materials found or offered on the Services for any particular
        purpose. You acknowledge that such information and materials may contain
        inaccuracies or errors and we expressly exclude liability for any such
        inaccuracies or errors to the extent permitted by law.
      </p>
      <h2>HOW WE MAY USE YOUR PERSONAL INFORMATION</h2>
      <p>
        These Terms refer to our Privacy Policy [insert link], which also apply
        to your use of our site. We will only use your personal information in
        accordance with our Privacy Policy.
      </p>
      <p>WE ARE NOT RESPONSIBLE FOR VIRUSES AND YOU MUST NOT INTRODUCE THEM</p>
      <p>
        We do not guarantee that our site will be secure or free from bugs or
        viruses.
      </p>
      <p>
        You are responsible for configuring your information technology,
        computer programmes and platform to access our site. You should use your
        own virus protection software.
      </p>
      <p>
        You must not misuse our site by knowingly introducing viruses, trojans,
        worms, logic bombs or other material that is malicious or
        technologically harmful. You must not attempt to gain unauthorised
        access to our site, the server on which our site is stored or any
        server, computer or database connected to our site. You must not attack
        our site via a denial-of-service attack or a distributed denial-of
        service attack. By breaching this provision, you would commit a criminal
        offence under the Computer Misuse Act 1990. We will report any such
        breach to the relevant law enforcement authorities and we will
        co-operate with those authorities by disclosing your identity to them.
        In the event of such a breach, your right to use our site will cease
        immediately.
      </p>
      <h2>RULES ABOUT LINKING TO OUR SITE</h2>
      <p>
        You may link to our home page, provided you do so in a way that is fair
        and legal and does not damage our reputation or take advantage of it.
      </p>
      <p>
        You must not establish a link in such a way as to suggest any form of
        association, approval or endorsement on our part where none exists.
      </p>
      <p>
        You must not establish a link to our site in any website that is not
        owned by you.
      </p>
      <p>
        Our site must not be framed on any other site, nor may you create a link
        to any part of our site other than the home page.
      </p>
      <p>We reserve the right to withdraw linking permission without notice.</p>
      <h2>WHICH COUNTRY’S LAWS APPLY TO ANY DISPUTES?</h2>
      <p>
        These Terms, their subject matter and their formation (and any
        non-contractual disputes or claims) are governed by English law. You and
        we both agree to the exclusive jurisdiction of the courts of England and
        Wales.
      </p>
    </Container>
  </Layout>
)

export default IndexPage
